import PropTypes from 'prop-types';
import React from 'react';
import { convertToHexString } from '../utils';

/**
 * label should have height of "32 points"
 * label should have height "0 points" (hidden) when NULL
 */
const Label = _ref => {
  let _ref$value = _ref.value,
    value = _ref$value === void 0 ? '' : _ref$value,
    _ref$className = _ref.className,
    className = _ref$className === void 0 ? '' : _ref$className,
    _ref$color = _ref.color,
    color = _ref$color === void 0 ? null : _ref$color;
  const showLabel = typeof value === 'string';
  const divStyles = {
    padding: '6.5px 0',
    minHeight: '32px'
  };
  const pStyles = {
    margin: '0',
    whiteSpace: 'pre-line'
  };
  if (color) {
    pStyles.color = convertToHexString(color);
  }
  return showLabel ? /*#__PURE__*/React.createElement("div", {
    className: "t-label ".concat(className),
    style: divStyles
  }, /*#__PURE__*/React.createElement("p", {
    style: pStyles
  }, value)) : null;
};
Label.propTypes = {
  className: PropTypes.string,
  value: PropTypes.string,
  color: PropTypes.shape({
    red: PropTypes.number,
    green: PropTypes.number,
    blue: PropTypes.number
  })
};
export default Label;